import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
import { applyMinimalFlatPrice } from '../utils/applyMinimalFlatPrice';
const PRICE_STALE_TIME_MILLISECONDS = 5_000;
const priceKeys = {
    all: ['prices'],
    get: (filter, scope) => ['prices', filter, scope],
};
export const priceOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: priceKeys.get(filter, scope),
        // A mounted price survives a re-render or a quick back-navigation, but is
        // never resurrected after its screen unmounts: the payload carries spot
        // availability (`estimated` / `reason`), which consumers gate the reserve
        // button on, so a resurrected entry could show a stale button state.
        staleTime: PRICE_STALE_TIME_MILLISECONDS,
        gcTime: 0,
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Price);
            const prices = await repo.get(filter, scope);
            return prices.map((price) => price.estimated ? { ...price, flatPrice: applyMinimalFlatPrice(price.flatPrice) } : price);
        },
    }),
};
